import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { TokenService } from '../services';
import { setRedirectUrl } from '../../factory';
import { MsalAuthService } from '../../services/msal.service';
import { catchError, map, of } from 'rxjs';

export const profileGuard: CanActivateFn = (route, state) => {
  const tokenService = inject(TokenService);
  const jwtToken = tokenService.getToken();
  const router = inject(Router);
  const msalAuthService = inject(MsalAuthService);

  if (jwtToken) {
    return true;
  }

  return msalAuthService.refreshTokensSilently().pipe(
    map((refreshed) => {
      if (refreshed && tokenService.getToken()) {
        return true;
      }

      setRedirectUrl();
      router.navigateByUrl('/login');
      return false;
    }),
    catchError(() => {
      setRedirectUrl();
      router.navigateByUrl('/login');
      return of(false);
    })
  );
};
